export * from './tab-group';
export { MdInkBar } from './ink-bar';
export { MdTabBody } from './tab-body';
export { MdTabHeader } from './tab-header';
export { MdTabLabelWrapper } from './tab-label-wrapper';
export { MdTab } from './tab';
export { MdTabLabel } from './tab-label';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/tabs/index.js
// module id = 674
// module chunks = 3